import React, {FunctionComponent, MouseEvent} from 'react';
import './Button.less';
import {InlineSpinner, InlineSpinnerStyles} from '../inline-spinner/InlineSpinner';

interface ButtonProps {
	isAutoWidth?: boolean,
	isText?: boolean,
	isLightText?: boolean,
	onClick: (e: MouseEvent) => void,
	isDisabled?: boolean,
	isLoading?: boolean,
	isOutlined?: boolean
}

export const Button: FunctionComponent<ButtonProps> = ({
																												 isAutoWidth,
																												 isText,
																												 isLightText,
																												 children,
																												 onClick,
																												 isDisabled,
																												 isLoading,
																												 isOutlined
																											 }) => {
	return (
		<a className={`button ${
			isAutoWidth ? 'button--auto-width' : ''
		} ${
			isDisabled ? 'button--disabled' : ''
		} ${
			isText ? 'button--text' : ''
		} ${
			isLightText ? 'button--light-text' : ''
		} ${
			isLoading ? 'button--loading' : ''
		} ${
			isOutlined ? 'button--outlined' : ''
		}`} onClick={isDisabled || isLoading ? () => {
		} : onClick}>
			{
				isLoading &&
				<span className="button__loading">
						<InlineSpinner style={InlineSpinnerStyles.PRIMARY}/>
					</span>
			}

			<span className="button__content">
				{
					children
				}
			</span>
		</a>
	);
};
